import { UserProcessMode, UserProcessStatus } from '@interfaces';

export const CHECKLIST_DOC_KEY = 'CHECKLIST_SHARED';
export const ADDITIONAL_DOCUMENTS_KEY = 'ADDITIONAL_DOCUMENTS';

// =================================================================================== APPLICATION DETAILS MAT-TABS CONFIG
export enum APP_DETAILS_TAB {
  'GENERAL' = 'GENERAL',
  'PRE_SURVEY' = 'PRE_SURVEY',
  'PERSONAL_DATA_FORM' = 'PERSONAL_DATA_FORM',
  'DOCS' = 'DOCS',
  'APPENDIX' = 'APPENDIX',
  'SUMMARY' = 'SUMMARY',
}

// Use this to construct correct queryParams in link referencing one of mat-tab inside management/application-details/...
export const APP_DETAILS_TAB_TO_INDEX: { [key: string]: number } = {
  [APP_DETAILS_TAB.GENERAL]: 0,
  [APP_DETAILS_TAB.PRE_SURVEY]: 1,
  [APP_DETAILS_TAB.PERSONAL_DATA_FORM]: 2,
  [APP_DETAILS_TAB.DOCS]: 3,
  [APP_DETAILS_TAB.APPENDIX]: 4,
  [APP_DETAILS_TAB.SUMMARY]: 5,
};

export const userProcessStatusToIndex = {
  [UserProcessStatus.FILLING_PRE_SURVEY]: '1',
  [UserProcessStatus.PRE_SURVEY_VERIFICATION]: '2',
  [UserProcessStatus.FILLING_DETAILS]: '3',
  [UserProcessStatus.COMPLETING_DOCUMENTS]: '4',
  [UserProcessStatus.READY_FOR_REVIEW]: '5',
  [UserProcessStatus.CHANGES_REQUESTED]: '6',
  [UserProcessStatus.APPROVED]: '7',
  [UserProcessStatus.REVIEWED_READY_TO_PRINT]: '8A',
  [UserProcessStatus.REVIEWED_READY_TO_PRINT_WAITING_FOR_DOCUMENTS_SIGNATURE]: '8B',
  [UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED]: '9A',
  [UserProcessStatus.DOCUMENTS_SIGNED_WAITING_FOR_VOIVO_OFFICE_VISIT_DATE]: '9B',
  [UserProcessStatus.OFFICE_VISIT_SCHEDULED]: '10',
  [UserProcessStatus.APPLICATION_SUBMITTED]: '11',
  [UserProcessStatus.DECISION_ISSUED]: '12',
  [UserProcessStatus.ARCHIVED]: '13',
};

export const disabledStatusesWhenMode = {
  // STANDARD mode assumes that Foreigner will go to the voivodeship office for the application submition
  // and he will bring his signed documents with him
  [UserProcessMode.STANDARD]: [
    UserProcessStatus.REVIEWED_READY_TO_PRINT_WAITING_FOR_DOCUMENTS_SIGNATURE, //6b
    UserProcessStatus.DOCUMENTS_SIGNED_WAITING_FOR_VOIVO_OFFICE_VISIT_DATE, //7b
  ],
  // SEMI_POST mode assumes that Foreigner will send signed documents to the company office OR
  // will come to signe the documents, then company office will submit his application by sending with post
  // then foreigner has to schedule office visit to submit fingerprints
  [UserProcessMode.SEMI_POST]: [
    UserProcessStatus.REVIEWED_READY_TO_PRINT, //6a
    UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED, //7a
  ],
  // UKR mode assumes that Foreigner will send signed documents to the company office OR
  // will come to sign the documents, then company office will submit his application by sending with post
  // then foreigner awaits for the decision and process finishes - UKR mode assumes that fingerprints were submitted before the temp. res. permit application start
  [UserProcessMode.UKR]: [
    UserProcessStatus.REVIEWED_READY_TO_PRINT, //6a
    UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED, //7a
    UserProcessStatus.DOCUMENTS_SIGNED_WAITING_FOR_VOIVO_OFFICE_VISIT_DATE, //7b
    UserProcessStatus.OFFICE_VISIT_SCHEDULED, //8
  ],
};

export const USER_PROCESS_STATUS_FOR_MANAGERS = {
  [UserProcessStatus.FILLING_PRE_SURVEY]: UserProcessStatus.FILLING_DETAILS,
  [UserProcessStatus.PRE_SURVEY_VERIFICATION]: UserProcessStatus.FILLING_DETAILS,
  [UserProcessStatus.FILLING_DETAILS]: UserProcessStatus.FILLING_DETAILS,
  [UserProcessStatus.COMPLETING_DOCUMENTS]: UserProcessStatus.COMPLETING_DOCUMENTS,
  [UserProcessStatus.READY_FOR_REVIEW]: UserProcessStatus.COMPLETING_DOCUMENTS,
  [UserProcessStatus.CHANGES_REQUESTED]: UserProcessStatus.CHANGES_REQUESTED,
  [UserProcessStatus.APPROVED]: UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED,
  [UserProcessStatus.REVIEWED_READY_TO_PRINT]: UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED,
  [UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED]: UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED,
  [UserProcessStatus.OFFICE_VISIT_SCHEDULED]: UserProcessStatus.OFFICE_VISIT_SCHEDULED,
  [UserProcessStatus.APPLICATION_SUBMITTED]: UserProcessStatus.APPLICATION_SUBMITTED,
  [UserProcessStatus.DECISION_ISSUED]: UserProcessStatus.DECISION_ISSUED,
  [UserProcessStatus.ARCHIVED]: UserProcessStatus.ARCHIVED,
};

export const statusesAllowedPerPath = {
  preSurvey: [UserProcessStatus.FILLING_PRE_SURVEY, UserProcessStatus.PRE_SURVEY_VERIFICATION],
  personalDetails: [
    // EDIT MODE
    UserProcessStatus.FILLING_DETAILS,
    UserProcessStatus.COMPLETING_DOCUMENTS,
    UserProcessStatus.CHANGES_REQUESTED,

    // READ ONLY MODE
    UserProcessStatus.READY_FOR_REVIEW,
    UserProcessStatus.APPROVED,
    UserProcessStatus.REVIEWED_READY_TO_PRINT,
    UserProcessStatus.REVIEWED_READY_TO_PRINT_WAITING_FOR_DOCUMENTS_SIGNATURE,
    UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED,
    UserProcessStatus.DOCUMENTS_SIGNED_WAITING_FOR_VOIVO_OFFICE_VISIT_DATE,
    UserProcessStatus.OFFICE_VISIT_SCHEDULED,
    UserProcessStatus.APPLICATION_SUBMITTED,
    UserProcessStatus.DECISION_ISSUED,
  ],
  documents: [
    // EDIT MODE
    UserProcessStatus.COMPLETING_DOCUMENTS,
    UserProcessStatus.CHANGES_REQUESTED,
    UserProcessStatus.READY_FOR_REVIEW,

    // READ ONLY MODE
    UserProcessStatus.APPROVED,
    UserProcessStatus.REVIEWED_READY_TO_PRINT,
    UserProcessStatus.REVIEWED_READY_TO_PRINT_WAITING_FOR_DOCUMENTS_SIGNATURE,
    UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED,
    UserProcessStatus.DOCUMENTS_SIGNED_WAITING_FOR_VOIVO_OFFICE_VISIT_DATE,
    UserProcessStatus.OFFICE_VISIT_SCHEDULED,
    UserProcessStatus.APPLICATION_SUBMITTED,
    UserProcessStatus.DECISION_ISSUED,
  ],
  summary: [
    UserProcessStatus.REVIEWED_READY_TO_PRINT,
    UserProcessStatus.REVIEWED_READY_TO_PRINT_WAITING_FOR_DOCUMENTS_SIGNATURE,
    UserProcessStatus.DOCUMENTS_SIGNED_WAITING_FOR_VOIVO_OFFICE_VISIT_DATE,
    UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED,
    UserProcessStatus.OFFICE_VISIT_SCHEDULED,
    UserProcessStatus.APPROVED,
    UserProcessStatus.APPLICATION_SUBMITTED,
    UserProcessStatus.DECISION_ISSUED,
    UserProcessStatus.ARCHIVED,
  ],
};

/**
 * List of statuses that guarantee the user has already completed confirmPersonalDetails at least once.
 * Be cautious when adding new statuses here, as this may impact application behavior between the survey and document steps.
 */
export const ALLOWED_TO_READ_WITH_STATUSES: UserProcessStatus[] = [
  UserProcessStatus.APPROVED,
  UserProcessStatus.REVIEWED_READY_TO_PRINT,
  UserProcessStatus.REVIEWED_READY_TO_PRINT_WAITING_FOR_DOCUMENTS_SIGNATURE,
  UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED,
  UserProcessStatus.DOCUMENTS_SIGNED_WAITING_FOR_VOIVO_OFFICE_VISIT_DATE,
  UserProcessStatus.OFFICE_VISIT_SCHEDULED,
  UserProcessStatus.APPLICATION_SUBMITTED,
  UserProcessStatus.DECISION_ISSUED,
];

export const ALLOWED_TO_READ_ONLY_PERSONAL_DETAILS_WITH_STATUSES: UserProcessStatus[] = [
  UserProcessStatus.READY_FOR_REVIEW,
  UserProcessStatus.APPROVED,
  UserProcessStatus.REVIEWED_READY_TO_PRINT,
  UserProcessStatus.REVIEWED_READY_TO_PRINT_WAITING_FOR_DOCUMENTS_SIGNATURE,
  UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED,
  UserProcessStatus.DOCUMENTS_SIGNED_WAITING_FOR_VOIVO_OFFICE_VISIT_DATE,
  UserProcessStatus.OFFICE_VISIT_SCHEDULED,
  UserProcessStatus.APPLICATION_SUBMITTED,
  UserProcessStatus.DECISION_ISSUED,
];

export const ALLOWED_TO_READ_ONLY_DOCUMENT_WITH_STATUSES: UserProcessStatus[] = [
  UserProcessStatus.APPROVED,
  UserProcessStatus.REVIEWED_READY_TO_PRINT,
  UserProcessStatus.REVIEWED_READY_TO_PRINT_WAITING_FOR_DOCUMENTS_SIGNATURE,
  UserProcessStatus.OFFICE_VISIT_AVAILABILITY_PROVIDED,
  UserProcessStatus.DOCUMENTS_SIGNED_WAITING_FOR_VOIVO_OFFICE_VISIT_DATE,
  UserProcessStatus.OFFICE_VISIT_SCHEDULED,
  UserProcessStatus.APPLICATION_SUBMITTED,
  UserProcessStatus.DECISION_ISSUED,
];

export const getAppDetailsTabNameByTabIndex = (index: number): APP_DETAILS_TAB => {
  const [tabName] = Object.entries(APP_DETAILS_TAB_TO_INDEX).find(([, tabIndex]) => {
    return tabIndex === index;
  });
  return tabName as APP_DETAILS_TAB;
};
